import { NAV_ELEMENT_SELECTOR } from "./constants";

const getListElement = () => {
  const navElement = document.querySelector(NAV_ELEMENT_SELECTOR);

  let listElement = navElement.querySelector("ol");

  if (!listElement) {
    listElement = document.createElement("ol");

    navElement.appendChild(listElement);
  }

  return listElement;
};

export default getListElement;
